import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'dream_flavor'

export default function DreamFlavorPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'What flavor do your dreams have?',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.dreamFlavor.heading')}
      buttons={[
        {
          text: `🫐 ${t('pages.onboarding.dreamFlavor.options.surrealStrange')}`,
          value: 'Surreal & strange Nothing makes sense, but it feels right',
          subtext: t('pages.onboarding.dreamFlavor.subtexts.surrealStrange'),
        },
        {
          text: `🍒 ${t('pages.onboarding.dreamFlavor.options.romanticDeep')}`,
          value: 'Romantic & deep All heart, all longing, all the feels',
          subtext: t('pages.onboarding.dreamFlavor.subtexts.romanticDeep'),
        },
        {
          text: `🌶️ ${t('pages.onboarding.dreamFlavor.options.intenseWild')}`,
          value: 'Intense & wild High-speed drama with plot twists',
          subtext: t('pages.onboarding.dreamFlavor.subtexts.intenseWild'),
        },
        {
          text: `🌫️ ${t('pages.onboarding.dreamFlavor.options.mistyAbstract')}`,
          value: 'Misty & abstract Ca not quite grab them, but they linger',
          subtext: t('pages.onboarding.dreamFlavor.subtexts.mistyAbstract'),
        },
        {
          text: `🪨 ${t('pages.onboarding.dreamFlavor.options.downToEarth')}`,
          value: 'Down-to-earth My dreams are weirdly real',
          subtext: t('pages.onboarding.dreamFlavor.subtexts.downToEarth'),
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
